class QuantityManager {
    constructor(configuratorId) {
        this.configurator = $('body .pc-configurator-popup[data-configurator-id="' + configuratorId + '"]');
        this.quantityInput = this.configurator.find('.pc-quantity-input');
        this.quantityTable = this.configurator.find('.pc-quantity-table');
        this.priceCalculator = new PriceCalculator();
        this.initEvents();
    }


    initEvents() {
        // Обработка ввода в input
        this.quantityInput.on('input change', (e) => {
            const value = parseInt(e.target.value) || 1;
            this.updateQuantity(value);
        });

        // Обработка клика по строке таблицы
        this.quantityTable.find('tr').not('.pc-custom-quantity-row').on('click', (e) => {
            console.log('click');
            const row = $(e.currentTarget);
            if (row.is('th')) return;

            const value = parseFloat(row.find('td').first().text());
            if (value) {
                this.quantityInput.val(value);
                this.updateQuantity(value);
            }

            this.quantityTable.find('tr').removeClass('active');
            row.addClass('active');

        });

        $(document).on('price-updated', (e, priceData) => {
            console.log('price-updated', priceData);
            if (this.customRow.hasClass('active')) {
                const qty = parseInt(this.quantityInput.val()) || 1;
                const price = priceData.pricePerOne * qty;
                this.customRow.find('.pc-price-cell .price').text(price.toFixed(2));
                this.customRow.find('.pc-price-cell').attr('data-price', price);
            }
        });
    }

    updateQuantity(value) {
        this.quantityTable.find('tr').removeClass('active');
        console.log(value);

        this.quantityTable.find('tr').each((i, row) => {
            const rowValue = parseInt($(row).find('td').first().text());
            if (rowValue === value) {
                $(row).addClass('active');
            }
        });

        if(this.priceCalculator){
            this.priceCalculator.calculate(this.configurator.data('configurator-id'));
        }

        $(document).trigger('quantity-changed', [value]);
    }
}